export default {
	title: "Transacciones",
	titleForeign: "Productos",
	activeTab: "transactions",
	valueTransactioned: "Valor Transaccionado",
	value: "Valor Bruto Emitido",
	netValue: "Valor Neto Emitido",
	period: "Período",
	export: "Exportar Excel",
	filterIssued: "Emitidos",
	filterIssuedLabel: "Filtrar por estado",
	filterNotIssued: "No emitidos",
	descriptionForeign:
		"En este informe, es posible tener una visión de la facturación fiscal emitida considerando cada producto transaccionado, con la opción de filtrar por período y estado. El valor bruto emitido incluye el Impuesto sobre el Valor Agregado (IVA), mientras que el valor neto emitido se calcula después del descuento del IVA.",
	columns: {
		transactionId: "Id de la Transacción",
		productName: "Producto",
		count: "Cant.",
		value: "Valor unitario",
		total: "Valor total",
		netValue: "Valor Neto",
		discountValue: "Descuento",
		date: "Fecha",
		isCombo: "Combo",
		eventName: "Evento",
		eventDate: "Fecha evento",
		cnpj: "CNPJ Emisor",
		cpf: "CPF Cliente",
		type: "Tipo",
		issuerNIF: "NIF Comerciante",
		recipientNIF: "NIF Cliente",
		invoiceSeries: "Serie factura",
		invoiceNumber: "Nº factura",
		invoiceValue: "Valor factura",
		invoiceNetValue: "Valor factura neto",
		invoiceDate: "Fecha Emisión",
	},
	sheet: {
		title: "Transacciones",
		titleForeign: "Productos",
		filename: "transacciones",
		filenameForeign: "productos",
		columns: {
			transactionId: "Id de la Transacción",
			productName: "Producto",
			count: "Cantidad",
			value: "Valor unitario",
			total: "Valor total",
			netValue: "Valor Neto",
			discountValue: "Descuento",
			date: "Fecha",
			isCombo: "Es Combo",
			eventName: "Evento",
			eventDate: "Fecha evento",
			cnpj: "CNPJ Emisor",
			cpf: "CPF Cliente",
			type: "Tipo",
			issuerNIF: "NIF Comerciante",
			recipientNIF: "NIF Cliente",
			invoiceSeries: "Serie factura",
			invoiceNumber: "Nº factura",
			invoiceValue: "Valor factura",
			invoiceNetValue: "Valor factura neto",
			invoiceDate: "Fecha Emisión",
		},
	},
};
